<template>
  <div class="bgPage min-height-for-section w-100">
    <div class="container-fluid mb-4">
      <div class="row mt-md-5">
        <div class="col-12">
          <div
            class="w-100 d-flex flex-column align-items-center justify-content-center mb-4"
          >
            <div class="icon-logo mb-3">
              <img
                src="../assets/RTMKlik_favicon_curve.png"
                class="w-100 h-100"
                alt=""
              />
            </div>
            <div class="w-100 header-container">
              <h3 class="header-text my-2">
                RTMKLIK AKAUN
              </h3>
              <p class="mb-0 header-desc">
                Selamat datang! Sila masukkan maklumat akaun untuk log masuk ke
                akaun anda.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-4">
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.username)"
                  >
                    <label class="w-100 inputLabelText">Username</label>
                    <input
                      type="text"
                      name="username"
                      class="form-control"
                      required
                      v-model.lazy="model.username"
                    />

                    <field-messages
                      name="username"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan Username(e-mel) anda
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.password)"
                  >
                    <label class="w-100 inputLabelText">Kata Laluan</label>
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      required
                      v-model.lazy="model.password"
                    />

                    <field-messages
                      auto-label
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan kata laluan anda
                      </div>
                      <div slot="password" class="error">
                        Kata laluan anda tidak tepat
                      </div>
                    </field-messages>
                  </validate>
                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>

                  <div class="w-100 my-2 d-flex justify-content-end">
                    <router-link class="" :to="'/forget-password'">
                      <div class="w-100 d-flex flex-row justify-content-center">
                        <span class="ml-2 signup-text">Lupa kata laluan?</span>
                      </div>
                    </router-link>
                  </div>
                  <div class="py-2 text-center w-100">
                    <button class="modal-default-button" type="submit">
                      Hantar
                    </button>
                  </div>
                </vue-form>
                <!-- divider -->
                <!-- hide fb login for now -->
                <!-- <div class="w-100 position-relative mt-3 mb-3">
                  <h1 class="form-title">Atau</h1>
                </div>
                <div class="w-100 my-2 d-flex justify-content-center">
                  <v-facebook-login
                    app-id="626479622424740"
                    @login="FBlogin"
                    @sdk-init="handleSdkInit"
                    v-model="fbmodel"
                    version="v14.0"
                  ></v-facebook-login>
                </div> -->
                <div class="w-100 my-2 d-flex justify-content-center">
                  <!-- <button
                    v-google-signin-button="clientId"
                    class="google-signin-button"
                  >
                    Continue with Google
                  </button> -->
                  <div
                    id="buttonDiv"
                    ref="myDiv"
                    class="w-100 d-flex justify-content-center"
                  ></div>
                </div>
                <!-- social login -->
                <!-- <div class="w-100 my-2 d-flex justify-content-center">
                  <v-facebook-login app-id="390930505996364"></v-facebook-login>
                </div> -->
                <!-- register link -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <router-link class="" :to="code ? `/register/${code}` : '/register'">
            <p class="textSignUp">
              Masih belum mendaftar?
              <span class="signup-text">&nbsp;Daftar disini</span>
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import GoogleSignInButton from "vue-google-signin-button-directive";
import VFacebookLogin from "vue-facebook-login-component";
import { mapGetters, mapActions } from "vuex";
const google = window.google;
export default {
  components: {
    VFacebookLogin,
  },
  directives: {
    GoogleSignInButton,
  },
  data() {
    return {
      formstate: {},
      errorMsg: "",
      model: {
        username: "",
        password: "",
      },
      clientId:
        "59591394700-dju6uqka1e9arcuqkp99f6cbc7q4n1of.apps.googleusercontent.com",
      FB: {},
      scope: {},
      fbmodel: {},
      code: this.$route.params.code,
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
      fbSignIn: "auth/FBsignIn",
      GoogleSignIn: "auth/GoogleSignIn",
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        console.log("i");
      });
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
    handleCredentialResponse(response) {
      var vm = this;

      var body = {
        id_token: response.credential,
      };

      if (vm.code) {
        vm.GoogleSignIn(body)
          .then(() => {
            vm.errorMsg = "";
            const authToken = localStorage.getItem("token");

            $.ajax({
              type: "POST",
              url: "https://rtm.glueapi.io/v3/authenticate/code",
              contentType: "application/json; charset=utf-8",
              headers: {
                "X-AUTH-TOKEN": `${authToken}`,
              },
              data: JSON.stringify({
                code: vm.code,
              }),
              dataType: "json",
              success: function(data) {
                vm.$router.replace({
                  name: "home_new",
                });
                vm.errorMsg = "";
              },
              error: function(xhr, status, error) {
                vm.signOut();
                var jsonResponse = JSON.parse(xhr.responseText);
                vm.errorMsg = jsonResponse.error.displayMessage;
              },
            });
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      } else {
        vm.GoogleSignIn(body)
          .then(() => {
            vm.$router.replace({
              name: "home_new",
            });
            vm.errorMsg = "";
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      }
    },
    renderGoogleBtn() {
      // google.accounts.id.prompt(); // also display the One Tap dialog

      var vm = this;
      if (process.browser) {
        window.google = window.google;

        if (window.google) {
          window.google.accounts.id.initialize({
            client_id:
              "59591394700-dju6uqka1e9arcuqkp99f6cbc7q4n1of.apps.googleusercontent.com",
            callback: vm.handleCredentialResponse,
          });

          Vue.nextTick(
            function() {
              window.google.accounts.id.renderButton(
                vm.$refs.myDiv,
                { theme: "outline", size: "large" } // customization attributes
              );
            }.bind(vm)
          );
        }
      }
    },
    FBlogin(response) {
      // console.log(response);
      var vm = this;
      var body = {
        accessToken: response.authResponse.accessToken,
        expiresIn: response.authResponse.expiresIn,
      };

      if (vm.code) {
        vm.fbSignIn(body)
          .then(() => {
            vm.errorMsg = "";
            const authToken = localStorage.getItem("token");

            $.ajax({
              type: "POST",
              url: "https://rtm.glueapi.io/v3/authenticate/code",
              contentType: "application/json; charset=utf-8",
              headers: {
                "X-AUTH-TOKEN": `${authToken}`,
              },
              data: JSON.stringify({
                code: vm.code,
              }),
              dataType: "json",
              success: function(data) {
                vm.$router.replace({
                  name: "home_new",
                });
                vm.errorMsg = "";
              },
              error: function(xhr, status, error) {
                vm.signOut();
                vm.logoutFromFacebook();
                var jsonResponse = JSON.parse(xhr.responseText);
                vm.errorMsg = jsonResponse.error.displayMessage;
              },
            });
          })
          .catch(function(error) {
            // vm.errorMsg = error
            // console.log("error " + JSON.stringify(error.response, null, 2));
            vm.logoutFromFacebook();
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      } else {
        vm.fbSignIn(body)
          .then(() => {
            vm.$router.replace({
              name: "home_new",
            });
            vm.errorMsg = "";
            vm.logoutFromFacebook();
          })
          .catch(function(error) {
            // vm.errorMsg = error
            // console.log("error " + JSON.stringify(error.response, null, 2));
            vm.logoutFromFacebook();
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      }
    },
    logoutFromFacebook() {
      this.scope.logout();
    },
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    onSubmit: function(e) {
      e.preventDefault();
      let vm = this;

      if (vm.code) {
        vm.signIn(vm.model)
          .then(() => {
            vm.errorMsg = "";
            const authToken = localStorage.getItem("token");

            $.ajax({
              type: "POST",
              url: "https://rtm.glueapi.io/v3/authenticate/code",
              contentType: "application/json; charset=utf-8",
              headers: {
                "X-AUTH-TOKEN": `${authToken}`,
              },
              data: JSON.stringify({
                code: vm.code,
              }),
              dataType: "json",
              success: function(data) {
                // vm.$router.replace({
                //   name: "home_new",
                // });

                vm.$router.push({ name: "home_new" }).then(() => {
                  vm.$router.go();
                });

                vm.errorMsg = "";
              },
              error: function(xhr, status, error) {
                vm.signOut();
                var jsonResponse = JSON.parse(xhr.responseText);
                vm.errorMsg = jsonResponse.error.displayMessage;
              },
            });
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      } else {
        vm.signIn(vm.model)
          .then(() => {
            vm.$router.replace({
              name: "home_new",
            });
            vm.errorMsg = "";
          })
          .catch(function(error) {
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      }
    },
    OnGoogleAuthSuccess(idToken) {
      var vm = this;
      var body = {
        id_token: idToken,
      };

      vm.GoogleSignIn(body)
        .then(() => {
          vm.$router.replace({
            name: "home_new",
          });
          vm.errorMsg = "";
        })
        .catch(function(error) {
          // vm.errorMsg = error
          // console.log("error " + JSON.stringify(error.response, null, 2));
          vm.errorMsg = error.response.data.error.errors[0].message;
        });
    },
    OnGoogleAuthFail(error) {
      // console.log(error);
    },
  },
  mounted() {},
  beforeMount() {
    setTimeout(
      function() {
        this.renderGoogleBtn();
      }.bind(this),
      2000
    );
  },
};
</script>

<style scoped>
.min-height-for-section {
  min-height: 80vh;
  padding: 4rem 0;
}
.bgPage {
  background: url("../assets/rtmklik/bg-login-v2.png") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.pt-livetv {
  padding: 9rem 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.signup-text {
  color: #d9e021;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.inputLabelText {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  background: var(--bg-colour-box-card, #171f26);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06),
    0px 4px 8px -2px rgba(16, 24, 40, 0.1);
}
.header-container {
  max-width: 480px;
}
.header-text {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.header-desc {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.textSignUp {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.form-control:focus {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.form-group label {
  text-align: left;
}
.form-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  padding: 10px 14px;
  align-items: center;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 14px;
  margin-top: 4px;
}
.modal-default-button {
  width: 100%;
  display: flex;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #d9e021;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  outline: none;
}
.icon-logo {
  width: 80px;
  height: 80px;
}
h1 {
  overflow: hidden;
  text-align: center;
}

h1:before,
h1:after {
  background-color: #dae12f;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
  color: #dae12f;
}

h1:before {
  right: 0.5em;
  margin-left: -50%;
}

h1:after {
  left: 0.5em;
  margin-right: -50%;
}
.google-signin-button {
  width: 240px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.google-signin-button .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  background-color: #fff;
}
.google-signin-button .google-icon {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.google-signin-button .btn-text {
  float: right;
  margin: 11px 11px 0 0;
  color: #fff;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Roboto";
}
.google-signin-button button {
  border: none;
  background: transparent;
  margin-left: 39px;
}
.google-signin-button:hover {
  box-shadow: 0 0 6px #4285f4;
}
.google-signin-button:active {
  background: #1669f2;
}
@media screen and (max-width: 768px) {
  /* .pt-livetv {
    padding: 8px 0 0;
  } */
  .breadCrumbsWrapper {
    padding: 14px;
  }
  .bgPage {
    background: #000;
  }
}
</style>
